import { Routes } from '@angular/router';
import { rolesGuard } from '@core/auth/guards/role.guard';
import { modalGuard } from '@core/guards/modal.guard';

const PLUGIN_READ_ROLES = ['ROLE_APPLICATION_MARKETPLACE_PLUGIN_READ'];

export const routes: Routes = [
	{
		path: '',
		pathMatch: 'full',
		canActivate: [rolesGuard],
		data: { roles: PLUGIN_READ_ROLES },
		loadComponent: () =>
			import('./components/plugins/plugins.component').then(
				(m) => m.PluginsComponent
			),
		canDeactivate: [modalGuard]
	},
	{
		path: 'ontologies',
		canActivate: [rolesGuard],
		data: {
			breadcrumb: 'PLUGINS.TITLES.ONTOLOGIES',
			roles: PLUGIN_READ_ROLES
		},
		loadComponent: () =>
			import('./components/ontologies/ontologies.component').then(
				(m) => m.OntologiesComponent
			),
		canDeactivate: [modalGuard]
	},
	{
		path: 'ai-assistant',
		canActivate: [rolesGuard],
		data: {
			breadcrumb: 'PLUGINS.TITLES.AI_ASSISTANT',
			roles: PLUGIN_READ_ROLES
		},
		loadComponent: () =>
			import('./components/ai-assistant/ai-assistant.component').then(
				(m) => m.AiAssistantComponent
			),
		canDeactivate: [modalGuard]
	},
	{
		path: 'bpmn',
		canActivate: [rolesGuard],
		data: { breadcrumb: 'PLUGINS.TITLES.BPMN', roles: PLUGIN_READ_ROLES },
		loadComponent: () =>
			import('./components/bpmn/bpmn.component').then(
				(m) => m.BpmnPluginComponent
			),
		canDeactivate: [modalGuard]
	}
];
